/**
 * Which build of the interface this is: the commit and release tag the
 * application was built from, as its build recorded them and
 * `startPolygonChecks` was told. The API's own is GET /version.
 */
export interface AppVersion {
  /** The tag when there is one, otherwise the commit; `dev` for neither. */
  version: string
  commit: string | null
  tag: string | null
}

let current: AppVersion = { version: 'dev', commit: null, tag: null }

export function setAppVersion(version: AppVersion | undefined) {
  if (version) current = version
}

export const appVersion = (): AppVersion => current
